var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 97 97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #00497f;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 48.5,
    cy: 48.5,
    r: 48.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.9,16.9c1.6,2.5,3,5.2,4.9,7.4,3.7,4.2,7.8,8.1,11.6,12.2,4.4,4.6,8.1,9.8,9.2,16.3.4,2.7.7,5.5,1.1,8.2,0,1.2.5,2.3,1,3.4,1.2,3.6,3.7,5.9,7.4,6.6,1.9.4,3.8.7,5.7,1.4,1.2.5,2.2,1.6,3.3,2.5h0c-2.6-.5-5.3-.8-7.9-1.8-6.4-2.5-12.8-4.8-19.4-6.8-8.2-2.5-13.1-8.7-16-16.5-3-8.2-3.4-16.7-2.5-25.3.3-2.6.8-5.1,1.1-7.5.3,0,.5,0,.5,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.8073a9a2f99d8f398bd88b70a64fe0cf.svg";
export { ForwardRef as ReactComponent };